export const siteConfig = {
  name: '韩漫在线',
  description: '韩漫在线免费观看韩国漫画，包含好看的漫画大全，更新频繁体验佳，让您随时随地探索各种故事并享受无限阅读乐趣',
  tagline: '探索韩国漫画的无限世界，随时随地畅享阅读',
  url: 'http://zaixinjiaju.com/',
  logo: '韩漫在线',
};

export const navigationLinks = [
  { label: '首页', href: '/' },
  { label: '分类', href: '/category/all' },
  { label: '热门排行', href: '/category/all?sort=popular' },
  { label: '最新更新', href: '/category/all?sort=latest' },
  { label: '关于我们', href: '/about' },
];

export const heroData = {
  announcement: '每日更新 · 海量韩漫资源 · 完全免费',
  title: '韩漫在线',
  subtitle: '好看的韩国漫画大全',
  description: '汇聚全网热门韩国漫画，更新及时、画质高清，为您打造极致的在线阅读体验。无论你喜欢浪漫爱情还是热血冒险，这里都有属于你的故事。',
  primaryButton: '开始阅读',
  secondaryButton: '了解更多',
};

export const hotRecommendations = [
  {
    id: '1',
    title: '我的野蛮女友',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20romance%20comic%20cover%20art%2C%20beautiful%20couple%20illustration%2C%20soft%20pastel%20color%20palette%2C%20minimalist%20white%20background%2C%20clean%20editorial%20style%2C%20Korean%20manhwa%20art%2C%20delicate%20linework%2C%20emotional%20expressions%2C%20modern%20digital%20illustration%20with%20warm%20lighting&width=600&height=800&seq=manga-cover-01&orientation=portrait',
    category: '浪漫爱情',
    rating: 9.5,
    status: '连载中',
    isNew: true,
  },
  {
    id: '2',
    title: '热血高校',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20action%20school%20comic%20cover%2C%20dynamic%20fight%20scene%20illustration%2C%20intense%20red%20and%20dark%20tones%2C%20minimal%20background%2C%20clean%20graphic%20style%2C%20Korean%20manhwa%20art%2C%20bold%20linework%2C%20dramatic%20lighting%2C%20modern%20digital%20illustration&width=600&height=800&seq=manga-cover-02&orientation=portrait',
    category: '热血动作',
    rating: 9.2,
    status: '连载中',
  },
  {
    id: '3',
    title: '奇幻之旅',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20fantasy%20adventure%20comic%20cover%2C%20magical%20world%20illustration%2C%20soft%20ethereal%20light%20color%20palette%2C%20minimalist%20white%20background%2C%20clean%20art%20style%2C%20Korean%20manhwa%20art%2C%20delicate%20fantasy%20elements%2C%20modern%20digital%20illustration&width=600&height=800&seq=manga-cover-03&orientation=portrait',
    category: '奇幻冒险',
    rating: 9.7,
    status: '已完结',
  },
  {
    id: '4',
    title: '悬疑之夜',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20thriller%20mystery%20comic%20cover%2C%20dark%20atmospheric%20illustration%2C%20noir%20style%20with%20subtle%20highlights%2C%20minimal%20dark%20background%2C%20clean%20graphic%20art%2C%20Korean%20manhwa%20style%2C%20moody%20lighting%2C%20modern%20digital%20illustration&width=600&height=800&seq=manga-cover-04&orientation=portrait',
    category: '悬疑推理',
    rating: 9.0,
    status: '连载中',
    isNew: true,
  },
];

export const latestUpdates = [
  {
    id: '5',
    title: '恋爱方程式',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20romance%20scene%20with%20couple%20in%20cafe%2C%20warm%20color%20tones%2C%20soft%20lighting%2C%20Korean%20manhwa%20art%20style%2C%20clean%20minimalist%20composition%2C%20emotional%20atmosphere%2C%20modern%20digital%20illustration&width=800&height=500&seq=manga-update-01&orientation=landscape',
    category: '浪漫爱情',
    latestChapter: '第89话',
    updateTime: '2小时前',
  },
  {
    id: '6',
    title: '王者之路',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20action%20martial%20arts%20scene%2C%20dynamic%20movement%2C%20warm%20amber%20lighting%2C%20Korean%20manhwa%20art%20style%2C%20clean%20composition%2C%20dramatic%20atmosphere%2C%20modern%20digital%20illustration&width=800&height=500&seq=manga-update-02&orientation=landscape',
    category: '热血格斗',
    latestChapter: '第156话',
    updateTime: '5小时前',
  },
  {
    id: '7',
    title: '星辰大海',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20sci-fi%20space%20scene%2C%20dreamy%20cosmic%20colors%2C%20soft%20starlight%2C%20Korean%20manhwa%20art%20style%2C%20clean%20minimalist%20composition%2C%20peaceful%20atmosphere%2C%20modern%20digital%20illustration&width=800&height=500&seq=manga-update-03&orientation=landscape',
    category: '科幻未来',
    latestChapter: '第67话',
    updateTime: '1天前',
  },
  {
    id: '8',
    title: '恶女的重生',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20drama%20historical%20scene%20with%20elegant%20female%20character%2C%20warm%20amber%20and%20rose%20tones%2C%20Korean%20manhwa%20art%20style%2C%20clean%20composition%2C%20emotional%20atmosphere%2C%20modern%20digital%20illustration&width=800&height=500&seq=manga-update-04&orientation=landscape',
    category: '剧情重生',
    latestChapter: '第123话',
    updateTime: '1天前',
  },
];

export const categories = [
  { name: '浪漫爱情', slug: 'romance', icon: 'ri-heart-line', count: 328 },
  { name: '热血动作', slug: 'action', icon: 'ri-fire-line', count: 215 },
  { name: '奇幻冒险', slug: 'fantasy', icon: 'ri-magic-line', count: 187 },
  { name: '悬疑推理', slug: 'mystery', icon: 'ri-search-eye-line', count: 143 },
  { name: '剧情重生', slug: 'drama', icon: 'ri-restart-line', count: 169 },
  { name: '搞笑日常', slug: 'comedy', icon: 'ri-emotion-laugh-line', count: 256 },
  { name: '恐怖灵异', slug: 'horror', icon: 'ri-ghost-line', count: 98 },
  { name: '科幻未来', slug: 'scifi', icon: 'ri-rocket-line', count: 112 },
];

export const testimonials = [
  {
    name: '漫画迷小王',
    quote: '韩漫在线是我用过最好的漫画阅读平台，更新速度真的很快，画质也特别高清，每天必刷！',
    role: '忠实读者',
  },
  {
    name: '阅读达人Lisa',
    quote: '分类非常清晰，找漫画特别方便。资源也很全，很多冷门韩漫都能在这里找到。',
    role: 'VIP读者',
  },
  {
    name: '漫评人老张',
    quote: '作为一个看了十年韩漫的老读者，这个平台的体验真的没话说，界面简洁流畅，推荐！',
    role: '资深漫迷',
  },
];

export const faqItems = [
  {
    question: '韩漫在线是否完全免费？',
    answer: '是的，韩漫在线所有漫画内容完全免费，无需注册即可在线阅读。我们致力于为所有漫画爱好者提供优质的免费阅读体验。',
  },
  {
    question: '漫画更新频率如何？',
    answer: '我们保持每日更新的频率，热门漫画通常在原作更新后24小时内完成翻译和上线，确保您不错过任何精彩内容。',
  },
  {
    question: '是否支持手机阅读？',
    answer: '韩漫在线采用响应式设计，完美适配手机、平板和电脑等各类设备。无论您使用什么设备，都能获得流畅舒适的阅读体验。',
  },
  {
    question: '如何找到我喜欢的漫画类型？',
    answer: '您可以通过顶部的分类导航浏览不同类型的漫画，也可以使用搜索功能快速定位您想看的作品。首页的热门推荐也能帮您发现精彩内容。',
  },
];

export const footerLinks = {
  categories: [
    { label: '浪漫爱情', href: '/category/romance' },
    { label: '热血动作', href: '/category/action' },
    { label: '奇幻冒险', href: '/category/fantasy' },
    { label: '悬疑推理', href: '/category/mystery' },
  ],
  quickLinks: [
    { label: '热门排行', href: '/category/all?sort=popular' },
    { label: '最新更新', href: '/category/all?sort=latest' },
    { label: '关于我们', href: '/about' },
    { label: '联系方式', href: '/about#contact' },
  ],
  support: [
    { label: '常见问题', href: '/about#faq' },
    { label: '使用帮助', href: '/about#help' },
    { label: '内容声明', href: '/about#disclaimer' },
    { label: '版权说明', href: '/about#copyright' },
  ],
};